var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "result-search-page" } },
    [
      _c("div", { class: _vm.containerClasses }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "search-result-top" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "bottom space-between" }, [
              _c("div", { staticClass: "left" }, [
                _c("span", { staticClass: "showing" }, [
                  _c("strong", [_vm._v("Showing")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.from))]),
                  _vm._v("-"),
                  _c("span", [_vm._v(_vm._s(_vm.to))]),
                  _vm._v(" of "),
                  _c("span", [_vm._v(_vm._s(_vm.total))]),
                  _vm._v(
                    "\n                            results\n                        "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "view-type-selection" }, [
                  _c(
                    "label",
                    {
                      class: _vm.viewType === "grid" ? "active" : "",
                      attrs: { for: "view-grid" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.viewType,
                            expression: "viewType"
                          }
                        ],
                        attrs: {
                          id: "view-grid",
                          type: "radio",
                          value: "grid"
                        },
                        domProps: { checked: _vm._q(_vm.viewType, "grid") },
                        on: {
                          change: function($event) {
                            _vm.viewType = "grid"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("icon", { attrs: { icon: " fa-lg fa-th" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      class: _vm.viewType === "list" ? "active" : "",
                      attrs: { for: "view-list" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.viewType,
                            expression: "viewType"
                          }
                        ],
                        attrs: {
                          id: "view-list",
                          type: "radio",
                          value: "list"
                        },
                        domProps: { checked: _vm._q(_vm.viewType, "list") },
                        on: {
                          change: function($event) {
                            _vm.viewType = "list"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("icon", { attrs: { icon: " fa-lg fa-list" } })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.viewType === "grid"
                  ? _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.perRow,
                            expression: "perRow"
                          }
                        ],
                        staticClass: "per-row",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.perRow = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.vehicles_in_row_options, function(option) {
                        return _c(
                          "option",
                          { domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(option.text) +
                                "\n                            "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$userIsRole("dealer")
                  ? _c(
                      "div",
                      { staticClass: "div select-all" },
                      [
                        _c("user-selector", {
                          attrs: {
                            "include-me": false,
                            "filter-by-shared-sales-reps": true
                          },
                          on: { change: _vm.onChange },
                          model: {
                            value: _vm.userFilter,
                            callback: function($$v) {
                              _vm.userFilter = $$v
                            },
                            expression: "userFilter"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.userHasPrivilege("can_see_company_stock")
                  ? _c(
                      "div",
                      { staticClass: "div select-all" },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            on: { change: _vm.onChange },
                            model: {
                              value: _vm.includeCompanyStock,
                              callback: function($$v) {
                                _vm.includeCompanyStock = $$v
                              },
                              expression: "includeCompanyStock"
                            }
                          },
                          [
                            _vm._v(
                              "\n                                Include Company Stock\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "select-all" },
                  [
                    _c(
                      "el-select",
                      {
                        on: { change: _vm.onMakeChange },
                        model: {
                          value: _vm.makeFilter,
                          callback: function($$v) {
                            _vm.makeFilter = $$v
                          },
                          expression: "makeFilter"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { value: null, label: "Filter by make" }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.makes, function(item) {
                          return _c("el-option", {
                            key: item.make,
                            attrs: { label: item.make, value: item.make }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.makeFilter
                  ? _c(
                      "div",
                      { staticClass: "select-all" },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "mr-2",
                            attrs: { loading: _vm.modelsLoading },
                            on: { change: _vm.onChange },
                            model: {
                              value: _vm.modelFilter,
                              callback: function($$v) {
                                _vm.modelFilter = $$v
                              },
                              expression: "modelFilter"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { value: null, label: "Filter by model" }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.models, function(item) {
                              return _c("el-option", {
                                key: item.model,
                                attrs: { label: item.model, value: item.model }
                              })
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "select-all" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search"
                      }
                    ],
                    attrs: {
                      id: "filter-stockid",
                      type: "text",
                      placeholder: "Stock ID / Chassis",
                      title: "Search multiple by separating by comma or space"
                    },
                    domProps: { value: _vm.search },
                    on: {
                      keyup: _vm.onChange,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pull-right" }, [
                  _vm.$userIsAdmin()
                    ? _c(
                        "a",
                        {
                          staticClass: "btn",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.openSendEmailModalFunc()
                            }
                          }
                        },
                        [_vm._v("Send Email")]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container-table", attrs: { id: "bid-history" } },
            [
              _vm.viewType === "list"
                ? _c(
                    "div",
                    [
                      _c("b-table", {
                        staticClass: "list-table",
                        attrs: {
                          responsive: "",
                          "sort-by": _vm.sort_by,
                          "sort-desc": _vm.sort_desc,
                          fields: _vm.fields,
                          items: _vm.vehicle_stocks,
                          "no-local-sorting": true,
                          "show-empty": ""
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.sort_by = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.sort_by = $event
                          },
                          "update:sortDesc": function($event) {
                            _vm.sort_desc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.sort_desc = $event
                          },
                          "sort-changed": _vm.onChange
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "empty",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n                            No data is available...\n                        "
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(vehicle)",
                              fn: function(data) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getVehicleLink(data.item.id)
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.goToCar(data.item)
                                        }
                                      }
                                    },
                                    [
                                      data.item.front_image_url
                                        ? _c("img", {
                                            attrs: {
                                              src: data.item.front_image_url,
                                              alt: "Front",
                                              height: "50"
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(mileage)",
                              fn: function(data) {
                                return [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.numberWithCommas(data.item.mileage)
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(images)",
                              fn: function(data) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "image-hover-container" },
                                    [
                                      _c("vehicle-hover-images", {
                                        attrs: {
                                          vehicle: data.item,
                                          letters_only: true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(sold_price)",
                              fn: function(data) {
                                return [
                                  data.item.sold_price
                                    ? [
                                        _vm.countries[data.item.currency]
                                          ? [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.countries[
                                                      data.item.currency
                                                    ].sign
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.numberWithCommas(
                                                data.item.sold_price
                                              )
                                            ) +
                                            "\n                                " +
                                            _vm._s(data.item.currency) +
                                            "\n                            "
                                        )
                                      ]
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "cell(stock_id)",
                              fn: function(data) {
                                return [
                                  data.item.stock_id
                                    ? [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(data.item.stock_id) +
                                            "\n                            "
                                        )
                                      ]
                                    : data.item.sold &&
                                      data.item.sold.heiwa_stock_id
                                    ? [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              data.item.sold.heiwa_stock_id
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              data.item.green_tree_sync_id
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                ]
                              }
                            },
                            {
                              key: "row-details",
                              fn: function(row) {
                                return [
                                  _c("div", { staticClass: "details" }, [
                                    row.item.messages
                                      ? _c(
                                          "div",
                                          { staticClass: "all-bid" },
                                          _vm._l(row.item.messages, function(
                                            msg,
                                            index
                                          ) {
                                            return _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bid history-bid",
                                                  class:
                                                    _vm.selectedMessage &&
                                                    _vm.selectedMessage.id ===
                                                      msg.id
                                                      ? "selected"
                                                      : "",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.selectMessage(
                                                        msg
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "cross item"
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.deleteMessage(
                                                                msg.id,
                                                                row.item.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: require("../../../images/cross.svg"),
                                                              alt: "Collapse"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "date item"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            _vm.getDate(
                                                              msg.created_at
                                                            )
                                                          ) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "hour item"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            _vm.getTime(
                                                              msg.created_at
                                                            )
                                                          ) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "name item"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            msg.user.name
                                                          ) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "note item"
                                                    },
                                                    [
                                                      msg.rep_only
                                                        ? _c("strong", [
                                                            _vm._v("staff: ")
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(msg.message) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          }),
                                          0
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "history-buttons" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "link add-message",
                                            on: {
                                              click: function($event) {
                                                return _vm.openMessageModal(
                                                  row.item,
                                                  false
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        Add Message\n                                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        row.item.sbl_id && _vm.$userIsAdmin()
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "link staff-message",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openMessageModal(
                                                      row.item,
                                                      true
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        Staff Message\n                                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "cell(actions)",
                              fn: function(data) {
                                return [
                                  _vm.$userCan("edit_stock")
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.$laravelRoute(
                                              "vehicle-stock.edit",
                                              data.item.id
                                            )
                                          }
                                        },
                                        [_vm._v("Edit |")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$userCan("delete_stock")
                                    ? _c(
                                        "a",
                                        {
                                          attrs: { href: "#!" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.deleteVehicleStock(
                                                data.item.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Delete |")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getVehicleLink(data.item.id)
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.goToCar(data.item)
                                        }
                                      }
                                    },
                                    [_vm._v("View")]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          979563917
                        )
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass: "container-results",
                      attrs: { id: "container-results" }
                    },
                    [
                      _vm.vehicle_stocks.length === 0
                        ? _c("div", [
                            _vm._v(
                              "\n                        No vehicles\n                    "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.vehicle_stocks, function(vehicle) {
                        return _c(
                          "div",
                          { staticClass: "single-result-search" },
                          [
                            _c(
                              "div",
                              { staticClass: "container-single-result-search" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "stockid" },
                                  [
                                    _vm.$userIsAdmin()
                                      ? _c(
                                          "span",
                                          { staticClass: "checkbox" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.selected_ids,
                                                  expression: "selected_ids"
                                                }
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                id:
                                                  "select-vehicle-" + vehicle.id
                                              },
                                              domProps: {
                                                value: vehicle.id,
                                                checked: Array.isArray(
                                                  _vm.selected_ids
                                                )
                                                  ? _vm._i(
                                                      _vm.selected_ids,
                                                      vehicle.id
                                                    ) > -1
                                                  : _vm.selected_ids
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a = _vm.selected_ids,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = vehicle.id,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.selected_ids = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.selected_ids = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.selected_ids = $$c
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              attrs: {
                                                for:
                                                  "select-vehicle-" + vehicle.id
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return _vm.selectVehicle(
                                                    vehicle,
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    vehicle.sold &&
                                    vehicle.sold.heiwa_stock_id &&
                                    !vehicle.stock_id
                                      ? [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                vehicle.sold.heiwa_stock_id
                                              ) +
                                              "\n                                "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(vehicle.stock_id) +
                                              "\n                                "
                                          )
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "image-hover-container" },
                                  [
                                    _c("vehicle-hover-images", {
                                      attrs: { vehicle: vehicle }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "image-vehicle" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getVehicleLink(vehicle.id)
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.goToCar(vehicle)
                                        }
                                      }
                                    },
                                    [
                                      vehicle.front_image_url
                                        ? _c("img", {
                                            attrs: {
                                              src: vehicle.front_image_url,
                                              alt: "Front"
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "model" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(vehicle.year) +
                                      " " +
                                      _vm._s(vehicle.make)
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(vehicle.model)
                                    }
                                  }),
                                  _vm._v(
                                    " /\n                                "
                                  ),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(vehicle.grade)
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("strong", [_vm._v("Auction grade:")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "rating" }, [
                                    _vm._v(_vm._s(vehicle.rating))
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("strong", [_vm._v("KM:")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "mileage" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.numberWithCommas(vehicle.mileage)
                                      ) + "km"
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "details" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(vehicle.transmission) +
                                      " / " +
                                      _vm._s(
                                        _vm.convertEquipment(vehicle.equipment)
                                      ) +
                                      "\n                            "
                                  )
                                ]),
                                _vm._v(" "),
                                vehicle.sales_note
                                  ? _c("div", { staticClass: "notes" }, [
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(vehicle.sales_note)
                                        }
                                      })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "view-more" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link arrow",
                                      attrs: {
                                        href: _vm.getVehicleLink(vehicle.id)
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.goToCar(vehicle)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    View more\n                                "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l([1, 2, 3, 4, 5, 6, 7, 8], function(vehicle) {
                        return _c("div", {
                          staticClass: "single-result-search none"
                        })
                      })
                    ],
                    2
                  )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "bottom-container-result d-flex justify-content-end flex-wrap"
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c("a", { attrs: { href: _vm.csvLink, target: "_blank" } }, [
                    _vm._v("CSV")
                  ]),
                  _vm._v(" "),
                  _vm.total > 0
                    ? _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.total,
                          "per-page": _vm.per_page
                        },
                        model: {
                          value: _vm.current_page,
                          callback: function($$v) {
                            _vm.current_page = $$v
                          },
                          expression: "current_page"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("vehicle-stock-message", {
        ref: "vehicleStockMessage",
        on: { changed: _vm.onVehicleStockMessagesAdd }
      }),
      _vm._v(" "),
      _c("vehicle-stock-send-email", {
        attrs: { "vehicle-ids": _vm.selected_ids },
        model: {
          value: _vm.openSendEmailModal,
          callback: function($$v) {
            _vm.openSendEmailModal = $$v
          },
          expression: "openSendEmailModal"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "left" }, [
        _c("h2", [
          _vm._v(
            "\n                            My Garage\n                        "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a420d83", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a420d83","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/MyGarage/MyGaragePage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3a420d83","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/MyGarage/MyGaragePage.vue
// module chunks = 0